export default "__VITE_ASSET__DLxQEAYQ__"